var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66"}));
}

Twitter.defaultProps = {"width":"300","height":"300.25","viewBox":"-30 -20 340 340","xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
